export default {
  colors: {
    gray: {
      800: {
        default: "gray.800",
        _dark: "#242424",
      },
      700: {
        default: "gray.700",
        _dark: "#343434",
      },
      600: {
        default: "gray.600",
        _dark: "#454545",
      },
      500: {
        default: "gray.500",
        _dark: "#555555",
      },
      400: {
        default: "gray.400",
        _dark: "#666666",
      },
      300: {
        default: "gray.300",
        _dark: "#777777",
      },
      200: {
        default: "gray.200",
        _dark: "#888888",
      },
      100: {
        default: "gray.100",
        _dark: "#999999",
      },
    },
  },
};
